import { useState, useEffect } from 'react';

interface SectionInfo {
  id: string;
  isBlue: boolean;
  name: string;
}

export const useScrollSection = () => {
  const [currentSection, setCurrentSection] = useState<SectionInfo>({
    id: 'hero',
    isBlue: false,
    name: 'hero'
  });

  useEffect(() => {
    const sections = [
      { id: 'hero', isBlue: false, name: 'hero' },
      // { id: 'section-1', isBlue: false, name: 'Non vendiamo, negoziamo per te' },
      { id: 'section-2', isBlue: true, name: 'Il metodo Synergy' },
      { id: 'section-3', isBlue: false, name: 'Il tuo risparmio è il nostro interesse' },
      { id: 'contact-form', isBlue: true, name: 'Contact Form' },
      { id: 'how-it-works', isBlue: false, name: 'Contact Form' },
      { id: 'synergy-hub', isBlue: true, name: 'Synergy hub' },
      { id: 'why-synergy', isBlue: false, name: 'Perché conviene con Synergy' },
      { id: 'become-supplier', isBlue: false, name: 'Diventa un fornitore Synergy' },
      { id: 'about-us', isBlue: false, name: 'About Us' },
    ];

    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      // Attiva il cambio colore quando la sezione è a 200px dal top della viewport
      const triggerOffset = 40;
      
      // Find the current section based on scroll position
      let activeSection = sections[0];
      
      for (let i = 0; i < sections.length; i++) {
        const section = sections[i];
        const element = document.getElementById(section.id);
        
        if (element) {
          const rect = element.getBoundingClientRect();
          const elementTop = rect.top + window.scrollY;
          const elementBottom = elementTop + rect.height;
          
          // Per la sezione hero, usa una logica speciale
          if (section.id === 'hero') {
            // Se siamo nella sezione hero e non abbiamo ancora raggiunto la prossima sezione con il trigger
            if (i < sections.length - 1) {
              const nextElement = document.getElementById(sections[i + 1].id);
              if (nextElement) {
                const nextElementTop = nextElement.getBoundingClientRect().top + window.scrollY;
                if (scrollPosition < nextElementTop - triggerOffset) {
                  activeSection = section;
                  break;
                }
              }
            } else {
              // Se è l'ultima sezione, usa la logica normale
              if (scrollPosition < elementBottom) {
                activeSection = section;
                break;
              }
            }
          } else {
            // Per tutte le altre sezioni, usa la logica normale con trigger
            if (scrollPosition + triggerOffset >= elementTop && scrollPosition < elementBottom) {
              activeSection = section;
              break;
            }
          }
        }
      }
      
      setCurrentSection(activeSection);
    };

    // Initial check
    handleScroll();

    // Add scroll listener with throttling
    let ticking = false;
    const throttledHandleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', throttledHandleScroll);
    window.addEventListener('resize', handleScroll);

    return () => {
      window.removeEventListener('scroll', throttledHandleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  return currentSection;
};
